import {
  CdkConnectedOverlay,
  CdkOverlayOrigin,
  ConnectionPositionPair
} from '@angular/cdk/overlay'
import {Component, inject, input} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {TTutorialType} from '../../general/types'
import {UserService} from '../../services/user-service'

@Component({
  selector: 'smt-tutorials',
  imports: [
    CdkConnectedOverlay,
    MatIcon,
    MatIconButton
  ],
  templateUrl: './tutorials.html',
  styleUrl: './tutorials.scss',
})
export class Tutorials {

  public readonly userService = inject(UserService)

  public objectId = input.required<CdkOverlayOrigin>()
  public tutorialId = input.required<TTutorialType>()
  public tutorialText = input.required<string>()

  public tutorialPositions: ConnectionPositionPair[] = [
    {
      originX: 'center',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
      offsetY: -5, // Creates space for the downward triangle
      offsetX: 120
    }
  ]


  public removeTutorial(tutorial: TTutorialType) {
    this.userService.user.update(user => ({
      ...user,
      showTutorials: {
        ...user.showTutorials,
        [tutorial]: false
      }
    }))
  }
}
